import {useTranslation} from "react-i18next"

export default function ProgressBar({type, project, step, handleClickNavigation}) {
    const {t} = useTranslation()
    let selectedLanguage = useTranslation().i18n.language

    if (selectedLanguage === "fr") {
        selectedLanguage = "fr-FR"
    }

    const progressLevel = type === "st" ? {
        upload: selectedLanguage === "fr-FR" ? 5 : 2.5,
        lexicons: selectedLanguage === "fr-FR" ? 28.5 : 25,
        lexiconsDone: selectedLanguage === "fr-FR" ? 28.5 : 25,
        transcription: 50,
        translation: selectedLanguage === "fr-FR" ? 72 : 74,
        render: 100,
        archive: 100,
    } : {
        upload: selectedLanguage === "fr-FR" ? 6 : 3.5,
        transcription: selectedLanguage === "fr-FR" ? 37.5 : 35,
        generate_all_ecp: selectedLanguage === "fr-FR" ? 67.5 : 66,
        render: selectedLanguage === "fr-FR" ? 67.5 : 66,
        integration: 100,
    }

    return (
        <>
        <div className="progress-bar">
            <div className="line-1" style={{width: `${progressLevel[step]}%`}}>
                <div className="point"></div>
            </div>
            <div className="line-2"></div>
            <div className="state">
                {type === "st" ?
                    <>
                    <p className="color-primary" onClick={() => handleClickNavigation(1)} title={t("Settings")}>1. {t("Settings")}</p>
                    <p className="color-primary" onClick={() => handleClickNavigation(2)} title={t("Lexicons")}>2. {t("Lexicons")}</p>
                    <p className={(project.transcription_status === "done" && "color-primary") ||
                        (project.translation_status === "done" && "color-primary") ||
                        (project.render_status === "render" && "color-primary")} onClick={() => handleClickNavigation(3)} title={t("Transcription")}>3. {t("Transcription")}</p>
                    <p className={(project.translation_status === "done" && "color-primary") ||
                        (project.render_status === "render" && "color-primary")} onClick={() => handleClickNavigation(4)} title={t("Translation")}>4. {t("Translation")}</p>
                    <p className={project.render_status === "done" && "color-primary"} onClick={() => handleClickNavigation(5)} title={t("Preview")}>5. {t("Preview")}</p>
                    </>
                :
                    <>
                    <p className="color-primary" onClick={() => handleClickNavigation(1)} title={t("Settings")}>1. {t("Settings")}</p>
                    <p className={(project.transcription_status === "done" && "color-primary") ||
                        (project.translation_status === "done" && "color-primary") ||
                        (project.chunking_status === "done" && "color-primary")} onClick={() => handleClickNavigation(2)} title={t("Transcription")}>2. {t("Transcription")}</p>
                    <p className={project.generate_all_ecp_status === "done" && "color-primary"} onClick={() => handleClickNavigation(3)} title={t("Render")}>3. {t("Render")}</p>
                    <p className={project.finished && "color-primary"} onClick={() => handleClickNavigation(4)} title={t("Integration")}>4. {t("Integration")}</p>
                    </>
                }
            </div>
        </div>
        </>
    )
}